import React, { useState, useEffect } from 'react'
import Dropzone from 'react-dropzone-uploader'
import { Auth } from "aws-amplify";
import Axios from "axios";
import { API_ROUTES, FRONTEND_ROUTES } from 'src/config/api';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import './dropzone.css';

const imageBase64 = async (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      // event.target.result contains base64 encoded image
      const base64String = event.target.result;
      resolve(base64String)
    };
    reader.readAsDataURL(file);
  });
}

const ImageUpload = ({ organisation }) => {
  const [dropzoneHidden, setDropzoneHidden] = useState(false);
  const [image, setImage] = useState(null);

  const handleSubmit = async (files, allFiles) => {
    if (allFiles.length >= 1) {
      const image = await imageBase64(files[0].file);
      const type = files[0].file.type;
      const extension = files[0].file.name.split('.')[1];

      const user = await Auth.currentAuthenticatedUser();

      await Axios.put(
        API_ROUTES.user['organisation:image-upload'](organisation.organisation),
        JSON.stringify({ image, type, extension }),
        {
          headers: {
            Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setImage(image);
      setDropzoneHidden(true);
    }
  }

  useEffect(() => {
    let image = null;

    for (const organisationItem of organisation.organisations) {
      if (organisationItem.id === organisation.organisation) {
        image = organisationItem.image;
      }
    }

    if (image) {
      setImage(`${FRONTEND_ROUTES.assets.base()}${image}`);
    }
  }, [organisation]);

  return (

    <div>
        <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-4 border-b border-violet-900 pb-2">
          Organisation Image
        </h3>

      <div className="mt-4">
        <div className='bg-blue-50 px-2 py-2 border border-blue-200 border-rounded text-blue-900'>
          <InformationCircleIcon className='w-5 h-5 text-blue-700 inline mr-1' />
          <small>This image is displayed to customers on payment links and in the portal</small>
        </div>

        <div className="w-100 grid grid-cols-3 h-auto gap-2 mt-4">

          {organisation.organisation && dropzoneHidden === false && (
            <div className='bg-violet-100 text-violet-900 py-2 px-2 col-span-2 border border-dashed border-violet-800'>
              <Dropzone
                onSubmit={handleSubmit}
                dropzoneDisabled
                accept="image/*"
                maxFiles={1}
                inputContent="Drop image here or click to upload"
                PreviewComponent={null}
                multiple={false}
                submitButtonContent="Upload image"
                styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
              />
            </div>
          )}

          {image && (
            <img
              className="h-max-150px mb-2 border"
              alt="organisation"
              src={image}
            />
          )}

        </div>
      </div>
    </div>
  );
};
export default ImageUpload;
